import * as THREE from 'three';

export type CameraPresetId = 'overview' | 'isometric' | 'salon' | 'patio';

export interface CameraPreset {
  id: CameraPresetId;
  position: THREE.Vector3;
  target: THREE.Vector3;
  minPolar?: number;
  maxPolar?: number;
}

export const CAMERA_PRESETS: Record<CameraPresetId, CameraPreset> = {
  overview: {
    id: 'overview',
    position: new THREE.Vector3(28, 26, 28),
    target: new THREE.Vector3(0, 0.15, 0),
  },
  isometric: {
    id: 'isometric',
    position: new THREE.Vector3(30, 30, 30),
    target: new THREE.Vector3(0, 0, 0),
    minPolar: Math.PI / 4,
    maxPolar: Math.PI / 4,
  },
  salon: {
    id: 'salon',
    position: new THREE.Vector3(-6, 18, 14),
    target: new THREE.Vector3(-8, 0, 2),
  },
  patio: {
    id: 'patio',
    position: new THREE.Vector3(18, 16, 12),
    target: new THREE.Vector3(10, 0, 2),
  },
};

export function applyCameraPreset(
  camera: THREE.PerspectiveCamera,
  controls: { target: THREE.Vector3; minPolarAngle: number; maxPolarAngle: number; update: () => void },
  presetId: CameraPresetId,
): void {
  const p = CAMERA_PRESETS[presetId];
  camera.position.copy(p.position);
  controls.target.copy(p.target);
  if (p.minPolar != null && p.maxPolar != null) {
    controls.minPolarAngle = p.minPolar;
    controls.maxPolarAngle = p.maxPolar;
  } else {
    controls.minPolarAngle = 0.45;
    controls.maxPolarAngle = Math.PI / 2.35;
  }
  controls.update();
}
